import React from 'react';
import styled from 'styled-components';
import { BidderDto } from '../../../features/onsite/utils/bidderTypes';
import { theme } from '../../../assets/styles/theme';
import { SimpleLink } from '../../buttons/SimpleLink';
import BidderPhoto from './BidderPhoto';
import BidAmountInfo from './BidAmountInfo';
import BidderDetails from './BidderDetails';
import BidCreatedInfo from './BidCreatedInfo';
import ResignedBadge from './ResignedBadge';
import WinnerBadge from './WinnerBadge';

const HEIGHT_WITH_BADGE = 80;
const HEIGHT_WITHOUT_BADGE = 70;

const Container = styled(SimpleLink)<{ height: number }>`
  display: flex;
  width: 100%;
  height: ${props => props.height + 20}px;
  margin: 8px 0;
  align-items: center;
  flex-direction: row;
  border: 1px solid ${theme.color.lightGray};
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
`;

const MiddleContainer = styled.div`
  height: 100%;
  padding: 0 15px;
  flex: 1;
  justify-content: center;
`;

interface Props {
  bidder: BidderDto;
}

const BidderItem = ({ bidder }: Props) => {
  const hasBadge = bidder.winner || bidder.resigned;
  const height = hasBadge ? HEIGHT_WITH_BADGE : HEIGHT_WITHOUT_BADGE;

  return (
    <Container to={`/users/find-user/${bidder.id}`} height={height} target='_blank'>
      <BidderPhoto size={height} imageUrl={bidder.imageUrl} />
      <MiddleContainer>
        <BidderDetails bidder={bidder} />
        <BidCreatedInfo created={bidder.bid.created} />
        {bidder.winner && <WinnerBadge />}
        {bidder.resigned && <ResignedBadge />}
      </MiddleContainer>
      <BidAmountInfo amount={bidder.bid.amount} />
    </Container>
  );
};

export default BidderItem;
